import { httpClient2 } from "modules/core/utils/httpClient2";

import {
  ApproveBrainstormIdeaDto,
  FetchBrainstormIdeasDto,
  CreateBrainstormIdeaDto,
  UpdateBrainstormIdeaDto,
  RejectBrainstormIdeaDto
} from "../types/dto";
import { BrainstormIdea } from "../types/entities";
import {
  BrainstormIdeasResponse,
  BrainstormIdeasStatsResponse
} from "../types/res";

export const fetchBrainstormIdeas = async (params: FetchBrainstormIdeasDto) => {
  const response = await httpClient2.get<BrainstormIdeasResponse>(
    "/brainstorm_ideas",
    { params }
  );

  return response.data;
};

export const fetchBrainstormIdeasStats = async ({
  project_id
}: {
  project_id: string;
}) => {
  const response = await httpClient2.get<BrainstormIdeasStatsResponse>(
    "/brainstorm_ideas/stats",
    { params: { project_id, rollups: "project" } }
  );

  return response.data;
};

export const fetchBrainstormIdea = async ({ id }: { id: string }) => {
  const response = await httpClient2.get<BrainstormIdea>(
    `/brainstorm_ideas/${id}`
  );

  return response.data;
};

export const createBrainstormIdea = async (dto: CreateBrainstormIdeaDto) => {
  const response = await httpClient2.post<BrainstormIdea>(
    `/brainstorm_ideas`,
    dto
  );

  return response.data;
};

export const updateBrainstormIdea = async ({
  id,
  dto
}: {
  id: string;
  dto: UpdateBrainstormIdeaDto;
}) => {
  const response = await httpClient2.put<BrainstormIdea>(
    `/brainstorm_ideas/${id}`,
    dto
  );

  return response.data;
};

export const rejectBrainstormIdea = async ({
  id,
  dto
}: {
  id: string;
  dto: RejectBrainstormIdeaDto;
}) => {
  const response = await httpClient2.post(
    `/brainstorm_ideas/${id}/reject`,
    dto
  );

  return response.data;
};

export const approveBrainstormIdea = async ({
  id,
  dto
}: {
  id: string;
  dto: ApproveBrainstormIdeaDto;
}) => {
  const response = await httpClient2.post(
    `/brainstorm_ideas/${id}/approve`,
    dto
  );

  return response.data;
};

export const fetchBrainstormIdeaSynthesis = async ({
  id,
  project_id
}: {
  id: string;
  project_id: string;
}) => {
  const response = await httpClient2.post(
    `/brainstorm_ideas/${id}/synthesize`,
    {
      project_id,
      rollups: "project"
    }
  );

  return response.data;
};
